module.exports = __webpack_public_path__ + "img/document-upload.b8768518.svg";